<template>
  <v-checkbox
      dense
      v-bind="$attrs"
      outlined
      @change="$emit('change', $event)"
  >
  </v-checkbox>
</template>

<script>

export default {
  name: 'CommonFieldCheck',
  inheritAttrs: false,

  components: {},

  computed: {
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">

</style>
